import { createContext } from 'react';

const AttributesContext = createContext();

export default AttributesContext;
